<div id="emoji-container" *ngIf="hint.length > 0">
  <mat-list>
    <mat-list-item class="emoji-list" *ngFor="let emoji of hint" (click)="selectEmoji(emoji)">
      <img [src]="emoji.emojiSrc" />
      <span>:{{ emoji.shortcode }}:</span>
    </mat-list-item>
  </mat-list>
</div>
